/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlbumImageDto } from '../models/AlbumImageDto';
import type { UpdateAlbumImageRequest } from '../models/UpdateAlbumImageRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ImagesService {

  /**
   * @returns AlbumImageDto OK
   * @throws ApiError
   */
  public static getProjectImage({
    projectKey,
    imageId,
  }: {
    projectKey: string,
    imageId: string,
  }): CancelablePromise<AlbumImageDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/images/{imageId}',
      path: {
        'projectKey': projectKey,
        'imageId': imageId,
      },
    });
  }

  /**
   * @returns AlbumImageDto OK
   * @throws ApiError
   */
  public static updateProjectImage({
    projectKey,
    imageId,
    requestBody,
  }: {
    projectKey: string,
    imageId: string,
    requestBody?: UpdateAlbumImageRequest,
  }): CancelablePromise<AlbumImageDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/projects/{projectKey}/images/{imageId}',
      path: {
        'projectKey': projectKey,
        'imageId': imageId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static deleteProjectImage({
    projectKey,
    imageId,
  }: {
    projectKey: string,
    imageId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectKey}/images/{imageId}',
      path: {
        'projectKey': projectKey,
        'imageId': imageId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static getProjectImageContent({
    projectKey,
    imageId,
  }: {
    projectKey: string,
    imageId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/images/{imageId}/content',
      path: {
        'projectKey': projectKey,
        'imageId': imageId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static getProjectImageThumbnail({
    projectKey,
    imageId,
    size,
  }: {
    projectKey: string,
    imageId: string,
    size?: number,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/images/{imageId}/thumbnail',
      path: {
        'projectKey': projectKey,
        'imageId': imageId,
      },
      query: {
        'size': size,
      },
    });
  }

}
